const defaultFontSize = 14;
const controlHeightLG = 40;
const defaultBorderRadius = 6;
const defaultBorderRadiusLG = 8;
const appFontFamily = 'var(--app-font-family)';

const themeGlobal = {
  token: {
    fontFamily: appFontFamily,
    fontSize: defaultFontSize,
    controlHeight: controlHeightLG,
    controlHeightLG: controlHeightLG,
    borderRadius: defaultBorderRadius,
    borderRadiusLG: defaultBorderRadiusLG,
  },
  components: {
    Menu: {
      itemMarginBlock: 7,
      itemMarginInline: 0,
      itemPaddingInline: 0,
      activeBarBorderWidth: 0,
    },
    Form: {
      itemMarginBottom: 15,
    },
    Modal: {
      contentPadding: 10,
    },
    Card: {
      padding: 10,
      paddingLG: 15,
      boxShadow: 'none',
      borderRadiusLG: defaultBorderRadiusLG,
    },
    Tabs: {
      titleFontSizeLG: defaultFontSize,
    },
    Button: {
      fontSizeLG: defaultFontSize,
    },
    Input: {
      fontSizeLG: defaultFontSize,
      inputFontSizeLG: defaultFontSize,
      controlHeight: controlHeightLG,
      controlHeightLG: controlHeightLG,
      borderRadiusLG: defaultBorderRadius,
    },
    InputNumber: {
      fontSizeLG: defaultFontSize,
      controlHeightLG: controlHeightLG,
    },
    Tag: {
      fontSizeSM: defaultFontSize,
      lineHeightSM: 2.6666666666666665,
      borderRadiusSM: defaultBorderRadius,
    },
    DatePicker: {
      fontSizeLG: defaultFontSize,
      controlHeightLG: controlHeightLG,
      borderRadiusLG: defaultBorderRadius,
    },
    Select: {
      fontSizeLG: defaultFontSize,
      controlHeight: controlHeightLG,
      controlHeightLG: controlHeightLG,
      borderRadius: defaultBorderRadius,
      borderRadiusLG: defaultBorderRadius,
      singleItemHeightLG: controlHeightLG,
      showArrowPaddingInlineEnd: 30,
    },
    Segmented: {
      trackPadding: 2,
    },
    Dropdown: {
      borderRadiusLG: defaultBorderRadiusLG,
    },
    Divider: {
      fontSizeLG: defaultFontSize,
    },
  },
};

export default themeGlobal;
